import { parseRequiredDate } from '../../utils/parsing';
import { LiveBenchmarksResponse, PerformanceMetric } from './types';

// TODO: [axios] use zog?

type StringyItem = Omit<PerformanceMetric, 'start_time' | 'valid_time'> & {
  start_time: string;
  valid_time: string;
};

type StringyResponse = Omit<LiveBenchmarksResponse, 'metrics'> & {
  metrics: StringyItem[];
};

export function parseList(value: string | StringyResponse): LiveBenchmarksResponse {
  if (typeof value === 'string') {
    value = JSON.parse(value) as StringyResponse;
  }
  return {
    ...value,
    metrics: value.metrics.map(parseItem),
  };
}

export function parseItem(value: string | StringyItem): PerformanceMetric {
  if (typeof value === 'string') {
    value = JSON.parse(value) as StringyItem;
  }
  return {
    ...value,
    start_time: parseRequiredDate(value.start_time),
    valid_time: parseRequiredDate(value.valid_time),
  };
}
